// extracted by mini-css-extract-plugin
export var subtitle = "_bv-2";
export var title = "_bv-0";
export var titleNoWrap = "_bv-1";